<!-- ─── Top bar + toggle button ─────────────────────────────── -->
<mat-toolbar class="topBar">
  <button mat-icon-button (click)="navigateBack()" matTooltip="Back">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span class="flex-1">{{ title }}</span>
</mat-toolbar>  <!-- toggle calendars -->

<div class="date-controls">
  <button mat-button
          class="text-button"
          type="button"
          (click)="showCalendars = !showCalendars">
    {{ showCalendars ? 'Hide Dates' : 'Select Dates' }}
  </button>

  <span style="font-weight: 500; font-size: 18px;;">
    {{ formatRange(start(), end()) }}
  </span>
</div>

<!-- ─── Collapsible calendars ───────────────────────────────── -->
<div *ngIf="showCalendars" style="display:flex; gap:16px; margin:16px 0;">
  <div style="flex:1">
    <strong>Start date</strong>
    <mat-calendar
      [selected]="start()"
      [startAt]="start()"
      (selectedChange)="onStartDate($event)">
    </mat-calendar>
  </div>
  <div style="flex:1">
    <strong>End date</strong>
    <mat-calendar
      [selected]="end()"
      [startAt]="end()"
      (selectedChange)="onEndDate($event)">
    </mat-calendar>
  </div>
</div>
  
  <!-- ─── Combo Fishery: two separate tables ───────────────────────── -->
  <ng-container *ngIf="fishery === 'Groundfish + HMS'; else singleFishery">
  
    <h3>Groundfish - {{ completedGF() }} Completed @if (completedGF() == 1) {Delivery} @else {Deliveries}</h3>
    <table mat-table [dataSource]="catchGFItems" class="w-full mb-8">
  
      <!-- Species -->
      <ng-container matColumnDef="Species">
        <th mat-header-cell *matHeaderCellDef>Species</th>
        <td mat-cell *matCellDef="let c">{{ c.species.name }}</td>
      </ng-container>
  
      <!-- Retained Count -->
      <ng-container matColumnDef="RetainedCount">
        <th mat-header-cell *matHeaderCellDef>Count – Retained</th>
        <td mat-cell *matCellDef="let c">{{ c.retainedCount  ?? '–' }}</td>
      </ng-container>
  
      <!-- Retained Weight -->
      <ng-container matColumnDef="RetainedWeight">
        <th mat-header-cell *matHeaderCellDef>Weight – Retained</th>
        <td mat-cell *matCellDef="let c">{{ c.retainedWeight ?? '–' }}</td>
      </ng-container>
  
      <!-- Released Count -->
      <ng-container matColumnDef="ReleasedCount">
        <th mat-header-cell *matHeaderCellDef>Count – Released</th>
        <td mat-cell *matCellDef="let c">{{ c.releasedCount  ?? '–' }}</td>
      </ng-container>
  
      <!-- Released Weight -->
      <ng-container matColumnDef="ReleasedWeight">
        <th mat-header-cell *matHeaderCellDef>Weight – Released</th>
        <td mat-cell *matCellDef="let c">{{ c.releasedWeight ?? '–' }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row        *matRowDef="let r; columns: displayedColumns;"></tr>
    </table>
  
    <br/>

    <h3>HMS - {{ completedHMS() }} Completed @if(completedHMS() == 1) {Trip} @else {Trips} - {{ HMSDaysFished }} Day(s) Fished</h3>
    <table mat-table [dataSource]="catchHMSItems" class="w-full">
  
      <!-- Species -->
      <ng-container matColumnDef="Species">
        <th mat-header-cell *matHeaderCellDef>Species</th>
        <td mat-cell *matCellDef="let c">{{ c.species.name }}</td>
      </ng-container>
  
      <!-- Retained Count -->
      <ng-container matColumnDef="RetainedCount">
        <th mat-header-cell *matHeaderCellDef>Count – Retained</th>
        <td mat-cell *matCellDef="let c">{{ c.retainedCount  ?? '–' }}</td>
      </ng-container>
  
      <!-- Retained Weight -->
      <ng-container matColumnDef="RetainedWeight">
        <th mat-header-cell *matHeaderCellDef>Weight – Retained</th>
        <td mat-cell *matCellDef="let c">{{ c.retainedWeight ?? '–' }}</td>
      </ng-container>
  
      <!-- Released Count -->
      <ng-container matColumnDef="ReleasedCount">
        <th mat-header-cell *matHeaderCellDef>Count – Released</th>
        <td mat-cell *matCellDef="let c">{{ c.releasedCount  ?? '–' }}</td>
      </ng-container>
  
      <!-- Released Weight -->
      <ng-container matColumnDef="ReleasedWeight">
        <th mat-header-cell *matHeaderCellDef>Weight – Released</th>
        <td mat-cell *matCellDef="let c">{{ c.releasedWeight ?? '–' }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row        *matRowDef="let r; columns: displayedColumns;"></tr>
    </table>
  
  </ng-container>
  
  <!-- ─── Single‑fishery ──────────────────────────────────── -->
  <ng-template #singleFishery>

    @if (fishery == "HMS") {
      <h3 style="padding-left: 10px;">HMS - {{ completedHMS() }} Completed @if(completedHMS() == 1) {Trip} @else {Trips} - {{ HMSDaysFished }} Day(s) Fished</h3>
    } @else if (fishery == "Groundfish") {
      <h3 style="padding-left: 10px;">Groundfish Non-Trawl - {{ completedGF() }} Completed @if (completedGF() == 1) {Delivery} @else {Deliveries}</h3>
    } @else if (fishery == "Trawl") {
      <h3 style="padding-left: 10px;">Groundfish Trawl - {{ completedTrawl() }} Completed @if (completedTrawl() == 1) {Delivery} @else {Deliveries}</h3>
    }
    <h4 style="padding-left: 10px;"><b> Completed trips, Draft trips, and Current trip </b></h4>

    <table mat-table [dataSource]="catchItems" class="w-full">
  
      <!-- Species -->
      <ng-container matColumnDef="Species">
        <th mat-header-cell *matHeaderCellDef>Species</th>
        <td mat-cell *matCellDef="let c">{{ c.species.name }}</td>
      </ng-container>
  
      <!-- Retained Count -->
      <ng-container matColumnDef="RetainedCount">
        <th mat-header-cell *matHeaderCellDef>Count – Retained</th>
        <td mat-cell *matCellDef="let c">{{ c.retainedCount  ?? '–' }}</td>
      </ng-container>
  
      <!-- Retained Weight -->
      <ng-container matColumnDef="RetainedWeight">
        <th mat-header-cell *matHeaderCellDef>Weight – Retained</th>
        <td mat-cell *matCellDef="let c">{{ c.retainedWeight ?? '–' }}</td>
      </ng-container>
  
      <!-- Released Count -->
      <ng-container matColumnDef="ReleasedCount">
        <th mat-header-cell *matHeaderCellDef>Count – Released</th>
        <td mat-cell *matCellDef="let c">{{ c.releasedCount  ?? '–' }}</td>
      </ng-container>
  
      <!-- Released Weight -->
      <ng-container matColumnDef="ReleasedWeight">
        <th mat-header-cell *matHeaderCellDef>Weight – Released</th>
        <td mat-cell *matCellDef="let c">{{ c.releasedWeight ?? '–' }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row        *matRowDef="let r; columns: displayedColumns;"></tr>
    </table>
  </ng-template>
  